import { EVENTS_STATE } from './events-constants'

export const eventsSelector = state => state[EVENTS_STATE]
